import { useState } from "react";

const useCheckAvailableServices = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const checkAvailability = async (selectedInput) => {
        const { lng, lat } = selectedInput;

        try {
            setIsLoading(true);
            const response = await fetch(`/availability/check`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ coordinates: { lng, lat } }),
            });
            if (response) {
                const value = await response.json();
                setIsLoading(false);

                setData(value);

                return value;
            } else {
                setIsLoading(false);
                return false;
            }
        } catch (err) {
            setIsLoading(false);
            console.log("ERROR");
            throw new Error(err);
        }
    };

    return [data, checkAvailability, isLoading];
};

export default useCheckAvailableServices;
